export enum AccessLevels {
    qualificationLevel,
    programmeLevel,
    studentLevel
}
